import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Flex } from 'antd';
import { CloseOutlined, SyncOutlined } from '@ant-design/icons';
import { useSyncInvoicesToInfakt } from 'api/invoices/use-sync-invoices-to-infakt';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { useSelectInvoicesStore } from 'shared/stores/use-select-invoices.ts';

const InvoicesSyncActionComponent: React.FC = () => {
  const { t } = useTranslation('invoice');
  const { selectedInvoices, deleteAll } = useSelectInvoicesStore();
  const { mutate: syncToInfakt, isLoading } = useSyncInvoicesToInfakt();

  const selectedInvoiceIds = Array.from(selectedInvoices);
  const hasSelection = selectedInvoiceIds.length > 0;

  const handleSync = () => {
    syncToInfakt({ invoiceIds: selectedInvoiceIds }, { onSuccess: deleteAll });
  };

  return (
    <Flex gap='small'>
      <Button
        icon={<SyncOutlined spin={isLoading} />}
        loading={isLoading}
        disabled={!hasSelection}
        onClick={handleSync}>
        {t('send_to_infakt')} {hasSelection ? `(${selectedInvoiceIds.length})` : ''}
      </Button>
      {hasSelection && <Button icon={<CloseOutlined />} type='text' onClick={deleteAll} />}
    </Flex>
  );
};

export const InvoicesSyncAction = withRoleGuard(InvoicesSyncActionComponent, [
  UserRole.admin,
  UserRole.accountant,
  UserRole.assistant,
]);
